import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Ms_AdmissionELe from './Ms_admissionELe'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission"/>
            <Ms_AdmissionELe />
        </>
    )
}

export default Main